module.exports = __webpack_public_path__ + "img/el.b2e251c7.png";